export default function Services() {
    return (
        <>

            <section id="services" class="services">
                <div class="container" data-aos="fade-up">

                    <div class="section-title">
                        <h2>Serviços</h2>
                        <p>Serviços para cliente Netsim Telecom que deseja alterar o plano de velocidade, mudar os equipamento de lugar ou de endereço ou até mudar o titular responsavél pela internet</p>
                    </div>

                    <div class="row">
                        <div class="col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="100">
                            <div class="icon-box">
                                <i class="bi bi-house"></i>
                                <h4><a href="https://netsimtelecom.com.br/mudanca">Mudança de Endereço</a></h4>
                                <p>Destinado para clientes que deseja mudar os esquipamentos de uma casa para outra, no mesmo lotes, ou em lotes diferente.  
                                </p>
                              
                            </div>
                        </div>
                        <div class="col-md-6 d-flex align-items-stretch mt-4 mt-md-0" data-aos="fade-up" data-aos-delay="200">
                            <div class="icon-box">
                                <i class="bi bi-arrow-left-right"></i>
                                <h4><a href="https://netsimtelecom.com.br/ponto">Mudança de Ponto</a></h4>
                                <p>Destinado para clientes que deseja mudar os esquipamentos de lugar dentro da mesma casa. </p>
                            </div>
                        </div>
                        <div class="col-md-6 d-flex align-items-stretch mt-4 mt-md-0" data-aos="fade-up" data-aos-delay="300">
                            <div class="icon-box">
                                <i class="bi bi-people-fill"></i>
                                <h4><a href="https://netsimtelecom.com.br/titularidade">Mudança de Titularidade</a></h4>
                                <p>Destinado para clientes que deseja mudar o cadastro ou nome do responsavel pela internet. </p>
                            </div>
                        </div>
                        <div class="col-md-6 d-flex align-items-stretch mt-4 mt-md-0" data-aos="fade-up" data-aos-delay="400">
                            <div class="icon-box">
                                <i class="bi bi-wifi"></i>
                                <h4><a href="https://netsimtelecom.com.br/cobertura">Mudança de Plano</a></h4>
                                <p>Destinado para clientes que deseja mudar para um plano melhor ou menor.</p>
                            </div>
                        </div>


                    </div>

                </div>
            </section>

        </>
    )
}